<template>
    <span v-if="!!receiptIssueDate">
        {{ receiptIssueDate }}
    </span>
</template>

<script>
    import {issueDatesMonths} from '@/constants/issue-date-constants';

    export default {
        name: "IssueDateName",
        props: {
            value: Number
        },
        data: function () {
            return {
                receiptIssueDate: !!this.value ? this.findOptionByKey(this.value) : null
            }
        },
        methods: {
            findOptionByKey(key) {
                return issueDatesMonths[key] || null;
            }
        },
        watch: {
            value: function () {
                if (!!this.value) {
                    this.receiptIssueDate = this.findOptionByKey(this.value);
                }
            }
        }
    }
</script>

<style scoped>

</style>